








































































































import {
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { isFloat } from '@front-app/components/form/validation/validators';
import { useTiptapEditor } from '@front-app/components/form/tiptap/useTiptapEditor';
import { v } from '@front-app/components/form/validation/useValidation';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import EditorMenu from '@front-app/components/form/tiptap/EditorMenu.vue';
import EditorContent from '@front-app/components/form/tiptap/EditorContent.vue';
import EditorContainer from '@front-app/components/form/tiptap/EditorContainer.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import {
	LearningPart,
	LearningProgram,
} from '../Model';
import SelectSpeakers from './inputs/SelectSpeakers.vue';
import { useSelectSpeakers } from './inputs/selectSpeakers';

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		FormError,
		EditorMenu,
		EditorContent,
		EditorContainer,
		HelpTooltipBlock,
		SelectSpeakers,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		part: {
			type: Object as PropType<LearningPart>,
			required: true,
		},
		program: {
			type: Object as PropType<LearningProgram>,
			required: true,
		},
		groupId: {
			type: String,
			required: true,
		},
		isLoading: Boolean,
		isError: Boolean,
	},
	setup(props, ctx) {
		// Fields
		const name = ref('');
		watch(() => props.part.name, (curr) => {
			name.value = curr;
		}, { immediate: true });

		const identifier = ref('');
		watch(() => props.part.identifier, (curr) => {
			identifier.value = curr ?? '';
		}, { immediate: true });

		const {
			speakerIds,
			removeSpeaker,
			selectSpeaker,
		} = useSelectSpeakers(() => props.part.speakers);

		const credits = ref(0);
		const floatValidator = isFloat(2);
		const setCredits = (inputVal: string) => {
			credits.value = floatValidator.validator(inputVal) ? parseFloat(inputVal) : (inputVal as unknown as number);
		};
		watch(() => props.part.credits, (curr) => {
			credits.value = curr;
		}, { immediate: true });

		// Validation
		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.edit-part-form' });
		const validation = v({
			credits: {
				value: credits,
				rules: [floatValidator],
			},
		});

		// Rich text
		const el = ref(null as null | Element);
		const { editor } = useTiptapEditor(el);
		watch(() => props.part.description, (content) => {
			editor.chain().setContent(content).run();
		}, { immediate: true });

		// Submission
		const updatePart = async () => {
			validation.validate();

			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			const payload: Partial<LearningPart> = {
				name: name.value,
				identifier: identifier.value,
				description: editor.getHTML(),
				speakers: speakerIds.value,
				credits: credits.value,
			};

			ctx.emit('submit', payload);
		};

		return {
			name,
			identifier,
			speakerIds,
			credits,
			setCredits,
			validation,
			editor,
			updatePart,
			removeSpeaker,
			selectSpeaker,
			// Util
			submitButtonPalette: ButtonPalettes.PRIMARY,
			submitButtonsize: Size.LARGE,
		};
	},
});
